export interface Account {
    account_id: number;
    login: string;
    email: string;
    full_name: string;
    proxy_user?: Omit<Account, 'proxy_user'>;
    timezone: string;
    role: string;
    v2: boolean;
    first_v2_visit_date: string | null; // ISO 8601 date string
    use_12_hour: boolean;
    view_promo: boolean;
    site_config_message_dismissed?: boolean;
}

export enum AuthState {
    UNKNOWN,
    AUTHENTICATED,
    UNAUTHENTICATED,
    ERROR,
}

export interface AuthContextType {
    goToLogin: (path?: string) => void;
    logout: (path?: string) => void;
    login?: (username: string, password: string) => Promise<void>;
    account: Account;
    authState: AuthState;
    loadAccount: () => Promise<void>;
    isEnvOp: boolean;
}

export interface AuthContextImplementation {
    goToLogin: (path?: string) => void;
    logout: (isProxyUser: boolean, path?: string) => void;
    login?: (username: string, password: string) => Promise<void>;
}
